const SvgAi3 = (props) => (
  <>
    <path
      d="M48 1c25.92 0 47 21.08 47 47S73.92 95 48 95 1 73.92 1 48 22.08 1 48 1m0-1C21.49 0 0 21.49 0 48s21.49 48 48 48 48-21.49 48-48S74.51 0 48 0Z"
      fill={props.p50}
    />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="M56 48h88" />
    <circle cx={144} cy={48} r={4} fill={props.p50} />
    <circle cx={48} cy={48} r={8} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <path
      d="M144 289c25.92 0 47 21.08 47 47s-21.08 47-47 47-47-21.08-47-47 21.08-47 47-47m0-1c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48Z"
      fill={props.p50}
    />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="M136 336H48" />
    <circle cx={48} cy={336} r={4} fill={props.p50} />
    <circle cx={144} cy={336} r={8} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <path
      d="M144 97c25.92 0 47 21.08 47 47s-21.08 47-47 47-47-21.08-47-47 21.08-47 47-47m0-1c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48Z"
      fill={props.p50}
    />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="M144 152v88" />
    <circle cx={144} cy={240} r={4} fill={props.p50} />
    <circle cx={144} cy={144} r={8} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <path
      d="M48 193c25.92 0 47 21.08 47 47s-21.08 47-47 47-47-21.08-47-47 21.08-47 47-47m0-1c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48Z"
      fill={props.p50}
    />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="M48 232v-88" />
    <circle cx={48} cy={144} r={4} fill={props.p50} />
    <circle cx={48} cy={240} r={8} fill="none" stroke={props.p50} strokeMiterlimit={10} />
  </>
);

export default SvgAi3;
